module.exports = __webpack_public_path__ + "static/ec-common-ar-mobile-bb8871334b0aec1b1d5a6bee49e3da6f.png";